<div class="ad-copy-analysis">
    <span class="label" *ngIf="adcopy!=null">Ad copy analysis:</span>
    <span class="label" *ngIf="adcopy==null" >Ad copy analysis: <span style="padding-left:0.6rem ; color: #EF4444;">This is a new feature, you will need to re-run the report to get the emotion explanation.</span></span>
     <div style="padding-left:0.4rem ;" class="description">
      {{this.adcopy}}
     </div>
  </div>
  